export const LOADING_MARKETING = "LOADING_MARKETING";
export const GET_MARKETING = "GET_MARKETING";
export const POST_MARKETING_ID = "POST_MARKETING_ID";
export const PUT_MARKETING_ID = "PUT_MARKETING_ID";
export const DELETE_MARKETING_ID = "DELETE_MARKETING_ID";
export const POST_MARKETING_CAMPAIGN = "POST_MARKETING_CAMPAIGN";
export const PUT_MARKETING_CAMPAIGN = "PUT_MARKETING_CAMPAIGN";
export const POST_CAMPAIGN_DRAFT = "POST_CAMPAIGN_DRAFT";
export const PUT_CAMPAIGN_DRAFT = "PUT_CAMPAIGN_DRAFT";
export const GET_POSTS = "GET_POSTS";
export const REMOVE_POST = "REMOVE_POST";
export const GET_DRAFTS = "GET_POSTS";
export const FACEBOOK_POST = "FACEBOOK_POST";
export const LINKEDIN_POST = "LINKEDIN_POST";
export const GET_CAMPAIGNS_LIST = "GET_CAMPAIGNS_LIST";
export const GET_CAMPAIGNS_BYID = "GET_CAMPAIGNS_BYID";
export const GET_CAMPAIGN_DRAFT_BYID = "GET_CAMPAIGN_DRAFT_BYID";
export const GET_CAMPAIGN_DRAFT_LIST = "GET_CAMPAIGN_DRAFT_LIST";
export const DELETE_CAMPAIGN = "DELETE_CAMPAIGN";
export const DELETE_CAMPAIGN_DRAFT = "DELETE_CAMPAIGN_DRAFT";
export const UPDATE_CAMPAIGN_STATUS = "UPDATE_CAMPAIGN_STATUS";
export const PUBLISH_DRAFT = "PUBLISH_DRAFT";
export const GET_EVENT_TASK_LIST = "GET_EVENT_TASK_LIST";
export const POST_EVENT_TASK = "POST_EVENT_TASK";
export const PUT_EVENT_TASK_STATUS = "PUT_EVENT_TASK_STATUS";
export const GET_COST_LIST = "GET_COST_LIST";
export const GET_COST_BYID = "GET_COST_BYID";
export const POST_COST = "POST_COST";
export const PUT_COST = "PUT_COST";
export const DELETE_COST = "DELETE_COST";

export const GET_TASK_LIST = "GET_COST_TASK";
export const GET_TASK_BYID = "GET_TASK_BYID";
export const POST_TASK = "POST_TASK";
export const PUT_TASK = "PUT_TASK";
export const DELETE_TASK = "DELETE_TASK";

export const GET_ASSIGNEE_LIST = "GET_ASSIGNEE_LIST";

export const GET_CAMPAIGN_CONTENTS_BYID = "GET_CAMPAIGN_CONTENTS_BYID";
export const SOCIAL_POST = "SOCIAL_POST";

export const PUT_KPI = "PUT_KPI";
export const POST_KPI = "POST_KPI";
export const GET_MARKETING_PLAN = "GET_MARKETING_PLAN";
export const GET_MARKETING_TEMPLATE = "GET_MARKETING_TEMPLATE";
